import './Detail_upload.scss';
import React, { useState, useEffect } from "react";
import fnc from '../mymod/commFunction';
import fncS3 from '../mymod/commFunction3';
import fncS4 from '../mymod/commFunction4';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
// import { setIsModalTest, bookCode, setBookCode } from '../reduxToolkit/redux';


const Detail_upload = () => {
  // const fileFolder = process.env.REACT_APP_fileFolder;
  const s3_acaCode = fnc.getCookie('s3_acaCode');
  const fileFolder = `${process.env.REACT_APP_uploadFileFolder}/${s3_acaCode}` ;
  const dispatch = useDispatch();
  const classCode = useSelector(state => state.reduxStore.classCode);
  const className = useSelector(state => state.reduxStore.className);
  const lessonDate = useSelector(state => state.reduxStore.lessonDate);
  const parentCode = useSelector(state => state.reduxStore.lmsListCode);//parentCode
  const version = useSelector(state => state.reduxStore.version);

  const [list, setList] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [fileName, setFileName] = useState('');

  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
   
  useEffect(() => {
    fncSelect_list();
  }, [isRefresh]);

  function fncSelect_list() {
    const acaCode = fnc.getCookie('acaCode');
    const stCode = fnc.getCookie('stCode');
    
    fnc.sendAxios('/select/lms/course/fileDownload', { acaCode, parentCode }, (res) => {
      if (res && Array.isArray(res)) { 
        setList(getRecords(res));
      } else {
        console.log(res, "kuesbLmsRoutes");
      }
    });
  }

  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];     
        const fileCode = res[i]["fileCode"];
        const fileName = res[i]["fileName"];
        const kind = res[i]["kind"];
        const parentCode = res[i]["parentCode"];
        const code = res[i]["code"];
        const s3Key = res[i]["s3Key"];
        records.push({ sno, fileCode, fileName, kind, parentCode, code, s3Key });
    }
    return records;
  }

  function onClickTr() {
    // 클릭 이벤트 핸들러 내용 추가
  }

  // function onClickDownload(item) {   
  //   const rtn = window.confirm('파일을 다운로드하시겠습니까?3');
  //   if (!rtn) return null;

  //   // const fileFolder = "/web/kuesbLmsFileUpload/1000";
  //   const fileName = item.fileName;
  //   const fileNameCode = item.fileCode;
  //   const remoteFilePath = `${fileFolder}/${fileNameCode}`;

  //   fnc.sendAxiosBlob(`/downloadSftp`, { remoteFilePath, fileNameCode }, (res) => {
  //     if (res) {
  //       const url = window.URL.createObjectURL(new Blob([res], { type: 'application/octet-stream' }));
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.setAttribute('download', decodeURIComponent(fileName)); // 다운로드할 파일 이름 설정 및 디코딩
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       window.URL.revokeObjectURL(url);  // 생성된 URL 해제
  //     } else {
  //       console.log('Error during file download');
  //     }
  //   }); 
  // }

  function onClickDownload(item) {

    if (typeof version === 'string' && version.toLowerCase().includes('ios')) {
        onClickDownload_ios(item);
    } else {
        onClickDownload_pc(item);//android도 이걸로
    }
  }

  async function onClickDownload_pc(item) { // 이게 사용하는 것임 lmstec 파일업로드

    const rtn = window.confirm('파일을 다운로드하시겠습니까?');
    if(!rtn) return null;
    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;

    let s3FilePath = await fncS4.getS3PathDownLoad_rename( s3Key, fileName);//c20250427072508415_ccc.zip => ccc.zip

    if (s3FilePath) {
      const link = document.createElement('a');
      link.href = s3FilePath; // S3의 직접 다운로드 링크
      link.setAttribute('download', fileName); // 다운로드할 파일 이름 설정(직업 다운로드 시 안 먹혀) blob은 웹뷰에서 안먹혀
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }


  async function onClickDownload_ios(item) {//ios는 보안때문에 새 페이지를 거쳐서 직접 클릭으로 해야함 인코딩이 깨져
    const rtn = window.confirm('파일을 다운로드하시겠습니까?');
    if (!rtn) return;

    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;
  
    let s3FilePath = await fncS4.getS3PathDownLoad_rename(s3Key, fileName); // 예: c20250427072508415_ccc.zip => ccc.zip

    const encodedUrl = encodeURIComponent(s3FilePath);
    const path = `https://kuebs.org/fileDownloadWebpage?s3Url=${encodedUrl}`;

    if (path) {
      // iOS WebView 내에서 실행 중이고, callWebSite 핸들러가 존재할 경우
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callWebSite) {
        window.webkit.messageHandlers.callWebSite.postMessage(path); // Safari로 URL 전달
      } else {
        // fallback: 일반 웹브라우저에서는 새 창으로 열기
        window.open(path, '_blank');
      }
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }

  
  async function onClickDownload_android(item) {//이건 사용 안 함
    //안드로이드에서는 버튼을 무시하고 바로 다운로드 됨 (pc버전으로 사용하도록 복잡해 보여)
    const rtn = window.confirm('파일을 다운로드하시겠습니까?6');
    if (!rtn) return;
  
    const fileName = item.fileName;
    const fileNameCode = item.fileCode;
    const s3Key = item.s3Key;
  
    let s3FilePath = await fncS4.getS3PathDownLoad_rename(s3Key, fileName, 6000); // 예: c20250427072508415_ccc.zip => ccc.zip

    const encodedUrl = encodeURIComponent(s3FilePath);
    const path = `https://kuebs.org/fileDownloadWebpage?s3Url=${encodedUrl}`;

    if (path) {

      if (window.myJSInterface && typeof window.myJSInterface.callWebSite === 'function') {
        window.myJSInterface.callWebSite(s3FilePath);
      } else {
        // fallback: 웹브라우저용
        window.open(s3FilePath, '_blank');
      }
    } else {
      alert('S3 파일 경로가 올바르지 않습니다.');
    }
  }


  // async function onClickDownload(item) {
  //   const rtn = window.confirm('파일을 다운로드하시겠습니까?4');
  //   if (!rtn) return;
  
  //   alert(version);
  
  //   const fileName = item.fileName;
  //   const s3Key = item.s3Key;
  
  //   const s3FilePath = await fncS4.getS3PathDownLoad_rename(s3Key, fileName, 60000);
   
  //   console.log(fileName, 'fileName');
  //   console.log(s3Key, 's3Key');
  //     // fileName 인코딩 (ccc.zip → 그대로지만 안전하게 처리됨, 한글이면 인코딩됨)
  //   // const encodedFileName = encodeURIComponent(fileName);

  //   // presigned URL 생성부
  //   const originalUrl = s3FilePath; // presigned URL이 여기 반환된다고 가정

  //   // response-content-disposition 파라미터 보정해서 붙이기
  //   // const fixedUrl = `${originalUrl}&response-content-disposition=attachment%3B%20filename%2A%3DUTF-8''${encodedFileName}`;
  //   console.log(originalUrl, 'originalUrl2');

  //   if (originalUrl) {
  //     // iOS WebView 환경이면 Safari로 넘김
  //     // const path ='https://kuebs.org/fileDownloadWebpage';
  //     if (window.webkit?.messageHandlers?.callWebSite) {
  //       window.webkit.messageHandlers.callWebSite.postMessage(originalUrl);
  //     }
  
  //     // // 사용자에게 직접 클릭 가능한 링크도 제공
  //     // const link = document.createElement('a');
  //     // link.href = s3FilePath;
  //     // link.innerText = `📥 [${fileName}] 파일 다운로드`;
  //     // link.target = '_blank'; // 새 창에서 열기
  //     // link.style.display = 'block';
  //     // link.style.marginTop = '10px';
  //     // link.style.color = '#007BFF';
  //     // link.style.textDecoration = 'underline';
  
  //     // // 기존 링크가 있다면 제거하고 다시 추가 (중복 방지)
  //     // const existing = document.getElementById('download-link');
  //     // if (existing) existing.remove();
  
  //     // link.id = 'download-link';
  //     // document.body.appendChild(link);
  //   } else {
  //     alert('S3 파일 경로가 올바르지 않습니다.');
  //   }
  // }
  
  
  // function handleUpdate() {
  //   if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.callWebSite) {
  //     window.webkit.messageHandlers.callWebSite.postMessage("https://naver.com");
  //   } else {
  //     console.warn("iOS 웹뷰에서 실행되지 않음");
  //   }
  // }
  

const handleFileChange = (event) => {
  const file = event.target.files[0];
  if (file) {
    setFile(file);
    setFileName(file.name);
  } else {
    setFileName('');
  }
};

const handleUpload = async () => {
  if (!file) {
    alert('파일을 선택하세요.');
    return;
  }

  const rtn = window.confirm(`${fileName}을 업로드하시겠습니까?`);
  if (!rtn) return;

  try {
    const s3_acaCode = fnc.getCookie('s3_acaCode'); // 학원코드 가져오기
    // const folder = `public/sms`; // S3 폴더명 예시
    const folder = `${fileFolder}`;
    const expireSec = 600; // presigned URL 유효시간 (초)

     // ✅ 여기서 파일명 변환
     const fileCode = `${classCode}_${fileName}`;

    fnc.sendAxios('/generate-upload-url', {fileName: fileCode, fileType: file.type,
      folder: folder, sec: expireSec}, (presignedRes) => {
      if (presignedRes) {
          const { url, key } = presignedRes; 
          fncS4.axiosPutFile(url, file); // 2. presigned URL로 S3에 직접 파일 PUT
          fncInsertUploadRecord(key, fileCode);// 3. 업로드 성공 시, uploadRecord 등록
          // 4. 초기화
          document.getElementById('file-upload-input').value = '';
          setFile(null);
          setFileName('');
        } else {
          console.log('Error during file download');
        }    
      }); 
     
  } catch (err) {
    console.error('업로드 중 오류 발생:', err);
    alert('오류가 발생했습니다.');
  }
};

function fncInsertUploadRecord(s3Key, newFileName) {
  const acaCode = fnc.getCookie('acaCode');
  const code = fnc.fncSirialNum('v');
  const fileCode = newFileName;//`${classCode}_${fileName}`;
  const extension = file.name.split('.').pop();
  const kind = extension;

  fnc.sendAxios(`/insert/lmsTec/course/uploadRecord`, {
    acaCode, parentCode, classCode, fileCode, fileName, code, kind, s3Key }, (res) => {
    if (res) {
      setIsRefresh(prev => !prev);
      alert('완료되었습니다.');
    } else {
      console.log('uploadRecord 저장 중 오류');
    }
  });
}


function onClickDelete(item) {

const acaCode = fnc.getCookie('acaCode');
const sno = item.sno;
const s3Key = item.s3Key;

const rtn = window.confirm(`${item.fileName}을 \n삭제하시겠습니까?`);
if (!rtn) return null;


fnc.sendAxios(`/delete/lmsTec/course/upload`, { acaCode, sno }, (res) => {
  if (res) {
      deleteFile(s3Key);
  } else {
    console.log('kuesbLmsTecRoutes/Error during file download');
  }
}); 


  function deleteFile(s3Key) {
    fnc.sendAxios(`/delete-upload-file`, { s3Key }, (res) => {
      if (res) {
          setIsRefresh(!isRefresh);
      } else {
        console.log('sqlsvr');
      }
    }); 
  }

}


//============================================================
  return (
    <div className="Detail_upload">
      <div className="title">파일 업로드</div>
      <div className="wrap-main">
        <section className="section-main">
          <table className="table-hong table-main">
            <thead>
              <tr>
                <th>종류</th>
                <th>파일명</th>
                <th>다운로드</th>
                <th>삭제</th>
              </tr>
            </thead>
            <tbody>
              {list &&
                list.map((item, index) => (
                  <tr key={index} onClick={() => onClickTr(item, index)}>
                    <td>{item.kind}</td>
                    <td>{item.fileName}</td>
                    <td>
                      <Button
                        className="btnDownload"
                        onClick={() => onClickDownload(item)}
                      >
                        {'다운'}
                      </Button>
                    </td>

                    <td>
                     <Button
                        className="btnDelete"
                        onClick={() => onClickDelete(item)}
                      >
                        {'삭제'}
                      </Button>

                    </td>

                  </tr>
                ))}
            </tbody>
          </table>
        </section>
        <section className="section-upload">
          <div className="file-upload-container">
            <input
              type="file"
              id="file-upload-input"
              className="file-upload-input"
              onChange={handleFileChange}
            />

          <Button className='btnUpload' onClick={handleUpload}>파일 업로드</Button>

          </div>

         
         
        </section>
      
      </div>
    </div>
  );
};

export default Detail_upload;
